import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { get, intersection, isEmpty } from 'lodash'

const isPermitted = (userPermissions, permissions) =>
  isEmpty(permissions) || !isEmpty(intersection(permissions, userPermissions))

const isFeatureSupported = (features, featureName) => isEmpty(featureName) || get(features, featureName, false)

const getDisplayName = (prefix, comp) => `${prefix}(${comp.displayName || comp.name})`

export const authorized = (permissions, featureName) => {
  return (WrappedComponent) => {
    class HOC extends React.Component {
      static propTypes = {
        shouldShowComponent: PropTypes.bool,
      }
      static defaultProps = {
        shouldShowComponent: false,
      }
      render() {
        const { shouldShowComponent, ...rest } = this.props
        if (shouldShowComponent) {
          return <WrappedComponent {...rest} />
        }
        return <Redirect to={`${import.meta.env.BASE_URL}/home`} />
      }
    }
    HOC.displayName = getDisplayName('Authorized', WrappedComponent)
    return connect((store) => ({
      shouldShowComponent:
        isPermitted(store.user.record.Permissions, permissions) &&
        isFeatureSupported(store.college.record.Features, featureName),
    }))(HOC)
  }
}
